module.exports = __webpack_public_path__ + "img/24_43.82e55ac3.png";